export default __webpack_public_path__ + "static/media/frb.50f4d138.webp";